<template>
  <div class="box">
    <div class="recommend">
      <div class="head">
        <span class="name">榜单</span>
        <span
          :class="[type=='week'?'active':'','text']"
          @click="changeTag($event)"
          data-tag="week"
        >近一周人气</span>
        <span
          :class="[type=='month'?'active':'','text']"
          @click="changeTag($event)"
          data-tag="month"
        >近30日人气</span>
      </div>
      <div class="content">
        <!-- <div> -->
        <div
          v-for="(item,index) in books"
          :key="index"
          :class="[
					page_size*(current_page-1)+index+1==1||
					page_size*(current_page-1)+index+1==2||
					page_size*(current_page-1)+index+1==3?'front':'',
					'list',(index%2)==1?'has_border':''
					]"
        >
          <span class="status">{{page_size*(current_page-1)+index+1}}</span>
          <!-- <img :src="item.cover" alt="" class="book_cover" @click="toBookDetail(item.book_id)"> -->
          <router-link
            tag="a"
            :to="{path:'/bookDetail',query:{book_id:item.book_id}}"
            target="_blank"
            class="book_cover"
          >
            <img height width :src="item.cover" />
          </router-link>
          <!-- <img :src="item.cover" alt="" class="book_cover" @click="toBookDetail(item.book_id)" @mouseenter="showBig(item.book_id)" @mouseleave="hideBig()"> -->
          <transition name="slide-fade">
            <img :src="item.cover" class="book_cover_scale" v-show="showId==item.book_id" />
          </transition>
          <div class="right">
            <div class="book_title" @click="toBookDetail(item.book_id)" v-html="item.name">></div>
            <div class="second_title">
              <span class="key">作&nbsp;&nbsp;&nbsp;者：</span>
              <span class="name" v-if="item.author">{{item.author}}</span>
              <span class="name" v-else>不详</span>
            </div>
            <!-- <div class="second_title"><span class="key">卷&nbsp;&nbsp;&nbsp;数：</span><span  class="name">{{item.volumes}}</span></div> -->
            <!-- <div class="second_title">
								<span class="key">馆藏地：</span><span v-if="item.collect" class="name">{{item.collect}}</span><span v-else class="name">不详</span>
            </div>-->
          </div>
        </div>
        <!-- </div> -->
        <div class="pagination" v-if="total_pages>1">
          <el-pagination
            @prev-click="handlePre"
            @next-click="handleNext"
            @current-change="changePage"
            background
            layout="prev, pager, next"
            :page-size="1"
            :current-page="current_page"
            :total="total_pages"
          ></el-pagination>
        </div>
      </div>
      <!-- <div id="pagination" v-if="total_pages>1">
				<button class="pre" @click="toPre()" :disabled="pre_disabled">&#60;</button>
				<span class="current"><b> {{current_page}} </b> / {{total_pages}}</span>
				<button class="next" @click="toNext()"  :disabled="next_disabled">&#62;</button>
				<span class="input_box">
					第<input type="text" v-model="input_page" @keyup.enter="toPage()">页
				</span>
				<button class='confirm' @click="toPage()">确定</button>
      </div>-->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// import axios from '../../../config/axiosConfig.js'
export default {
  data() {
    return {
      current_page: 1,
      page_size: 8,
      total_pages: null,
      input_page: 1,
      type: "week",
      pre_disabled: true,
      next_disabled: false,
      books: null,
      showId: null
    };
  },
  metaInfo: {
    title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
      {
        name: "keywords",
        content: "中医基础理论,江有诰,王冰注,王叔和,脉经,灵枢,医学六要四诊法"
      },
      { name: "description", content: "千年医典数据库的热门推荐中医古籍" }
    ]
  },
  created() {
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },
  mounted() {
    this.getHot();
  },
  methods: {
    changeTag: function(e) {
      let tag = e.target.getAttribute("data-tag");
      // console.log(tag)
      this.type = tag;
      this.current_page = 1;
      this.pre_disabled = true;
      this.next_disabled = false;
      this.getHot();
    },
    getHot() {
      let that = this;
      let datas = {
        // user_id:'1',
        user_id: parseInt(that.$store.state.user_id),
        page: that.current_page,
        page_size: that.page_size,
        type: that.type
      };
      // console.log(datas)
      // console.log('------------')
      // console.log(this.$axios.defaults.baseURL)
      // console.log('------------')
      that.$axios
        .get("book/hot", {
          params: datas
        })
        .then(res => {
          // console.log(res.data)
          if (res.data.status_code == 200) {
            that.books = res.data.data.books;
            for (let i = 0; i < that.books.length; i++) {
              // console.log(that.books[i].name)
              let name_arr = that.books[i].name.split("");
              let name_arr_new = name_arr.join(
                '<span style="font-size:14px;color:#aaa;margin:0 2px">/</span>'
              );
              // console.log(name_arr_new)
              Vue.set(that.books[i], `name`, name_arr_new);
            }
            that.current_page = res.data.data.current_page;
            that.total_pages = res.data.data.total_pages;
            if (that.current_page == 1) {
              that.pre_disabled = true;
              that.next_disabled = false;
            } else if (that.current_page == that.total_pages) {
              that.pre_disabled = false;
              that.next_disabled = true;
            } else {
              that.pre_disabled = false;
              that.next_disabled = false;
            }
          } else {
            return false;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    // 点击前一页
    handlePre(val) {
      //val是pagination中的第几页
      // console.log(val)
      if (this.current_page > 1) {
        this.current_page -= 1;
        this.input_page = this.current_page;
        this.getHot();
      }
    },
    // 点击下一页
    handleNext(val) {
      if (this.current_page < this.total_pages) {
        this.current_page += 1;
        this.input_page = this.current_page;
        this.getHot();
      }
    },
    changePage(val) {
      // console.log(val)
      this.current_page = val;
      this.getHot();
    },
    // 到书详情
    toBookDetail(id) {
      // this.book_id = e.currentTarget.getAttribute('data-id')
      this.book_id = id;
      // console.log(this.book_id)
      this.$router.push({
        path: "/bookDetail",
        query: { book_id: this.book_id }
      });
    },
    showBig(id) {
      // console.log(id)
      this.showId = id;
      // console.log(this.showId)
    },
    hideBig() {
      this.showId = null;
    }
  }
};
function formatTitle(str) {}
</script>

<style lang="scss" scoped="" type="text/css">
.box {
  background: url(../../assets/public/bg1.png);
  padding: 40px 0 80px 0;
}
.recommend {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  padding: 40px 0 0 0;
  box-sizing: border-box;
  line-height: 1;
  .head {
    margin-left: 60px;
    .name {
      font-size: 22px;
      color: #666;
      vertical-align: middle;
      font-family: PingFangSC-Regular, sans-serif;
    }
    .text {
      font-size: 16px;
      vertical-align: middle;
      font-family: PingFangSC-Regular, sans-serif;
      color: #999;
      margin-left: 30px;
      cursor: pointer;
      &.active {
        color: #e6522b;
      }
    }
  }
  .content {
    margin-top: 36px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-bottom: 10px;
    .list {
      background: url("../../assets/public/recommend/hot_bg_ash@2x.png")
        no-repeat 60px top;
      background-size: 40px;
      width: 600px;
      padding: 0 60px 0 60px;
      box-sizing: border-box;
      margin-bottom: 50px;
      position: relative;
      display: inline-block;
      &.front {
        background: url("../../assets/public/recommend/hot_bg@2x.png") no-repeat
          60px top;
        background-size: 40px;
      }
      &.has_border {
        &:before {
          width: 1;
          height: 90px;
          display: block;
          content: "";
          border-left: 1px solid #eee;
          position: absolute;
          left: 0;
          top: 48px;
        }
      }
      .status {
        position: absolute;
        display: inline-block;
        width: 40px;
        text-align: center;
        top: 7px;
        left: 60px;
        color: #fff;
        font-size: 16px;
        font-family: PingFangSC-Regular, sans-serif;
      }
      .book_cover {
        width: 143px;
        margin-left: 48px;
        display: inline-block;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
      .book_cover_scale {
        width: 250px;
        position: absolute;
        right: 80px;
        top: 0;
        z-index: 100;
      }
      .right {
        display: inline-block;
        width: 260px;
        vertical-align: top;
        line-height: 1;
        margin-left: 22px;
        .book_title {
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
          margin-bottom: 7px;
          color: #333;
          margin-top: 7px;
          cursor: pointer;
          // font-family:FZGB10;
          font-family: PingFangSC-Medium, sans-serif;
          font-weight: 500;
        }
        .second_title {
          line-height: 28px;
          text-overflow: wrap;
          font-size: 16px;
          color: #666;
          font-family: PingFangSC-Light;
          font-weight: 300;
          span {
            font-family: inline-block;
            display: inline-block;
            &.key {
              width: 70px;
            }
            &.name {
              width: 183px;
              vertical-align: top;
            }
          }
        }
      }
    }
  }
}
</style>
<style>
/* // 分页 */
.content .pagination {
  margin: 10px auto 50px;
  width: 100%;
  text-align: center;
}
.content .el-pagination.is-background .btn-next,
.content .el-pagination.is-background .btn-prev {
  /* background: linear-gradient(
    -55deg,
    rgba(255, 124, 90, 1),
    rgba(230, 82, 43, 1)
  ); */
  background: #ff7c5a !important;
  color: #fff;
  min-width: 50px;
  height: 36px !important;
  line-height: 34px;
  border-radius: 4px;
  margin: 0 20px;
}
.content .el-icon {
  font-size: 14px;
  color: #fff;
}
.content .el-icon:disabled {
  background: #fff;
}
.content .el-icon:disabled .el-icon {
  color: #bfbfbf;
  border: 1px solid #ddd;
  min-width: 50px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
}
/* // 中间页码 */
.content .el-pager li {
  min-width: 38px !important;
  height: 38px !important;
  line-height: 38px !important;
  border-radius: 19px !important;
  font-size: 16px;
  border: 1px solid #ddd;
  color: #999;
  background-color: #fff !important;
  margin: 0 11px !important;
}
.content .el-pager li:hover {
  background: #ff7c5a !important;
  color: #fff !important;
  border: 1px transparent;
  line-height: 34px;
}
.content .el-pager li.active {
  background: #ff7c5a !important;
  /* background: linear-gradient(
    -55deg,
    rgba(255, 124, 90, 1),
    rgba(230, 82, 43, 1)
  ) !important; */
  color: #fff !important;
  line-height: 34px;
  border: 1px transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/page/recommend.vue